import Header from "../../Layouts/Header/Header";
import MainContainer from "../../UI/MainContainer";
import SubMainContainer from "../../UI/SubMainContainer";
import SideBar from "../../Layouts/SideBar/SideBar";
import useLogout from "../../../hooks/useLogout";
import DashboardData from "../../Dashboard/DashboardData";


const Dashboard = () => {

  return (
    <>
      <MainContainer>
        <Header />
        <SubMainContainer>
          <SideBar />
          <div className="rightCol">
            <div className="contentContainer">
              <DashboardData/>
              
            </div>
          </div>
        </SubMainContainer>
      </MainContainer>
    </>
  );
};

export default Dashboard;
